<template>
  <div
    class="custom-tooltip"
    :class="[
      $blockClass(blockClass, 'tooltip'),
    ]"
    tabindex="0"
  >
    <slot />

    <div
      ref="display"
      class="custom-tooltip__display"
      :class="[
        $blockClass(blockClass, 'tooltip-display'),
        `custom-tooltip__display--${location}`
      ]"
      role="tooltip"
      :style="`max-width: ${tooltipMaxWidth};`"
    >
      <div
        class="custom-tooltip__display-content text-mobile-small-mobile"
        :class="[
          $blockClass(blockClass, 'tooltip-display-content'),
        ]"
        v-text="text"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Custom tooltip (custom-tooltip)
 * -----------------------------------------------------------------------------
 * Wrapper component that displays a provided tooltip when hovering the element
 * passed into the components slot.
 * @param {String} text - Text to display within tooltip.
 * @param {String} blockClass - Block level class to be applied to the component
 * elements.
 *
 */
export default {
  name: 'CustomTooltip',

  props: {
    blockClass: {
      type: String,
      default: '',
    },

    text: {
      type: String,
      default: '',
      required: true,
    },

    tooltipMaxWidth: {
      type: String,
      default: 'auto',
    },
  },

  data() {
    return {
      cnvsGlobal: true,
      location: 'right',
    }
  },

  mounted() {
    this.caclulateTootipLocation()
  },

  methods: {

    /**
     * If there is no space to display the tooltip on the right (default) then
     * it displays on the left instead.
     */
    caclulateTootipLocation() {
      const width = this.$refs.display.offsetWidth
      const position = this.$el.getBoundingClientRect()
      const viewport = window.innerWidth
      const space = viewport - position.right

      if (space > width) {
        return
      }
      this.location = 'left'
    },
  },
}
</script>
